import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'sortByMissionDate'
})
export class SortByMissionDatePipe implements PipeTransform {
	transform(
		array: Array<{ missionRequest: MissionRequest; employeeName: string }>,
		sortOrder = 'asc'
	): any[] {
		if (!Array.isArray(array) || array.length === 0) {
			return array;
		}

		return array.sort((a, b) => {
			const dateA = new Date(a.missionRequest.date).getTime();
			const dateB = new Date(b.missionRequest.date).getTime();

			return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
		});
	}
}
